var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "tour-tooltip",
      class: [
        "tour-tooltip--" + _vm.position,
        { "tour-tooltip--congrats": _vm.congrats },
      ],
      style: _vm.tooltipStyle,
    },
    [
      _vm.position !== "center"
        ? _c("div", {
            staticClass: "tour-tooltip__arrow",
            class: "tour-tooltip__arrow--" + _vm.arrowSide,
          })
        : _vm._e(),
      !_vm.congrats
        ? _c("div", { staticClass: "tour-tooltip__progress" }, [
            _c("div", {
              staticClass: "tour-tooltip__progress-bar",
              style: { width: _vm.progressPercent + "%" },
            }),
          ])
        : _vm._e(),
      _c("div", { staticClass: "tour-tooltip__header" }, [
        _c("h4", { staticClass: "tour-tooltip__title" }, [
          _vm._v(_vm._s(_vm.$t(_vm.title))),
        ]),
      ]),
      _c("p", { staticClass: "tour-tooltip__content" }, [
        _vm._v(_vm._s(_vm.$t(_vm.content))),
      ]),
      _vm.congrats && _vm.finalCongrats
        ? _c("div", { staticClass: "tour-tooltip__footer" }, [
            _c(
              "button",
              {
                staticClass: "tour-tooltip__btn tour-tooltip__btn--primary",
                on: {
                  click: function ($event) {
                    return _vm.$emit("finish")
                  },
                },
              },
              [
                _vm._v(
                  "\n      " + _vm._s(_vm.$t("tours.nav.thanks")) + "\n    "
                ),
              ]
            ),
          ])
        : _vm.congrats
        ? _c("div", { staticClass: "tour-tooltip__footer" }, [
            _c(
              "button",
              {
                staticClass: "tour-tooltip__btn tour-tooltip__btn--outline",
                on: {
                  click: function ($event) {
                    return _vm.$emit("finish")
                  },
                },
              },
              [
                _vm._v(
                  "\n      " + _vm._s(_vm.$t("tours.nav.noThanks")) + "\n    "
                ),
              ]
            ),
            _c(
              "button",
              {
                staticClass: "tour-tooltip__btn tour-tooltip__btn--primary",
                on: {
                  click: function ($event) {
                    return _vm.$emit("continue")
                  },
                },
              },
              [_vm._v("\n      " + _vm._s(_vm.$t("tours.nav.yes")) + "\n    ")]
            ),
          ])
        : _vm.awaitClick && _vm.awaitClickOptional
        ? _c("div", { staticClass: "tour-tooltip__footer" }, [
            !_vm.isFirstStep && !_vm.hidePrev
              ? _c(
                  "button",
                  {
                    staticClass: "tour-tooltip__btn tour-tooltip__btn--outline",
                    on: {
                      click: function ($event) {
                        return _vm.$emit("prev")
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n      " + _vm._s(_vm.$t("tours.nav.prev")) + "\n    "
                    ),
                  ]
                )
              : _vm._e(),
            _c(
              "button",
              {
                staticClass: "tour-tooltip__btn tour-tooltip__btn--primary",
                on: {
                  click: function ($event) {
                    return _vm.$emit("next")
                  },
                },
              },
              [_vm._v("\n      " + _vm._s(_vm.$t("tours.nav.next")) + "\n    ")]
            ),
          ])
        : _vm.awaitClick
        ? _c("div", { staticClass: "tour-tooltip__footer" }, [
            !_vm.isFirstStep && !_vm.hidePrev
              ? _c(
                  "button",
                  {
                    staticClass: "tour-tooltip__btn tour-tooltip__btn--outline",
                    on: {
                      click: function ($event) {
                        return _vm.$emit("prev")
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n      " + _vm._s(_vm.$t("tours.nav.prev")) + "\n    "
                    ),
                  ]
                )
              : _vm._e(),
            _vm.canSkip
              ? _c(
                  "button",
                  {
                    staticClass: "tour-tooltip__btn tour-tooltip__btn--primary",
                    on: {
                      click: function ($event) {
                        return _vm.$emit("skip")
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n      " + _vm._s(_vm.$t("tours.nav.skip")) + "\n    "
                    ),
                  ]
                )
              : _vm._e(),
          ])
        : _c("div", { staticClass: "tour-tooltip__footer" }, [
            !_vm.isFirstStep &&
            !_vm.hidePrev &&
            (!_vm.isLastStep || _vm.hideFinish)
              ? _c(
                  "button",
                  {
                    staticClass: "tour-tooltip__btn tour-tooltip__btn--outline",
                    on: {
                      click: function ($event) {
                        return _vm.$emit("prev")
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n      " + _vm._s(_vm.$t("tours.nav.prev")) + "\n    "
                    ),
                  ]
                )
              : _vm._e(),
            !_vm.isLastStep
              ? _c(
                  "button",
                  {
                    staticClass: "tour-tooltip__btn tour-tooltip__btn--primary",
                    on: {
                      click: function ($event) {
                        return _vm.$emit("next")
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n      " + _vm._s(_vm.$t("tours.nav.next")) + "\n    "
                    ),
                  ]
                )
              : _vm._e(),
            _vm.isLastStep && !_vm.hideFinish
              ? _c(
                  "button",
                  {
                    staticClass: "tour-tooltip__btn tour-tooltip__btn--primary",
                    on: {
                      click: function ($event) {
                        return _vm.$emit("finish")
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n      " + _vm._s(_vm.$t("tours.nav.finish")) + "\n    "
                    ),
                  ]
                )
              : _vm._e(),
          ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }